import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface CoinflipGame {
  id: string;
  choice: 'heads' | 'tails';
  outcome: 'heads' | 'tails';
  amount: string;
  payout: string;
  won: boolean;
  createdAt: string;
}

interface GameState {
  currentGame: 'coinflip' | null;
  coinflip: {
    isPlaying: boolean;
    result: CoinflipGame | null;
    history: CoinflipGame[];
  };
  isLoading: boolean;
  error: string | null;
}

const initialState: GameState = {
  currentGame: null,
  coinflip: {
    isPlaying: false,
    result: null,
    history: [],
  },
  isLoading: false,
  error: null,
};

const gameSlice = createSlice({
  name: 'game',
  initialState,
  reducers: {
    setCurrentGame: (state, action: PayloadAction<'coinflip' | null>) => {
      state.currentGame = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    // Coinflip actions
    setCoinflipPlaying: (state, action: PayloadAction<boolean>) => {
      state.coinflip.isPlaying = action.payload;
    },
    setCoinflipResult: (state, action: PayloadAction<CoinflipGame>) => {
      state.coinflip.result = action.payload;
      state.coinflip.history.unshift(action.payload);
      state.coinflip.isPlaying = false;
    },
    setCoinflipHistory: (state, action: PayloadAction<CoinflipGame[]>) => {
      state.coinflip.history = action.payload;
    },
  },
});

export const {
  setCurrentGame,
  setLoading,
  setError,
  setCoinflipPlaying,
  setCoinflipResult,
  setCoinflipHistory,
} = gameSlice.actions;

export default gameSlice.reducer;